import { apiService } from '@/utils/api/index';

export default {
  /*
    GET
  */
  getProfile() {
    return apiService.tabGet('dashboard_msp/profile/');
  },

  getMatchmaking(page, size, query, filters, sort) {
    return apiService.get(
      `/dashboard_msp/matchmaking/list/?page=${page}&page_size=${size}&search=${query}&sort=${sort}${filters}`
    );
  },

  getMatchmakingDetail(id) {
    return apiService.get(`/dashboard_msp/matchmaking/details/${id}/`);
  },

  getCategories() {
    return apiService.tabGet('/dashboard_msp/directory/categories/');
  },

  getSettings() {
    return apiService.tabGet('/dashboard_msp/directory/settings/');
  },

  getBranding() {
    return apiService.tabGet('/dashboard_msp/directory/branding/');
  },

  getFilters(id) {
    return apiService.tabGet(`/dashboard_msp/filters/${id}/`);
  },

  getPotentialPartners(page, size, query) {
    return apiService.get(
      `/dashboard_msp/find_partners/?page=${page}&page_size=${size}&search=${query}`
    );
  },

  getPartners(page, size, query, filters, sort) {
    return apiService.get(
      `/dashboard_msp/manage_partners/?page=${page}&page_size=${size}&search=${query}&sort=${sort}${filters}`
    );
  },

  getInvitation(id) {
    return apiService.get(`dashboard_msp/manage_partners/invite/${id}`);
  },

  getPublicProfiles(page, size, query, sort, filters) {
    return apiService.get(
      `/dashboard_msp/public_profiles/?page=${page}&page_size=${size}&search=${query}&sort=${sort}${filters}`
    );
  },

  getPublicProfile(id) {
    return apiService.tabGet(`/dashboard_msp/public_profiles/${id}/`);
  },

  getShowcases(id) {
    return apiService.tabGet(`/dashboard_msp/public_profiles/${id}/showcases/`);
  },

  getLeads(id, page, size, query, filters, sort) {
    return apiService.tabGet(
      `/dashboard_msp/reseller/contacts/${id}/?page=${page}&page_size=${size}&search=${query}${filters}&sort=${sort}`
    );
  },

  getManagePartnersProfile(id) {
    return apiService.tabGet(`/dashboard_msp/manage_partners/${id}/`);
  },

  getManagePartnersUseCases(id) {
    return apiService.tabGet(`/dashboard_msp/manage_partners/${id}/use_cases/`);
  },

  getManagePartnersQuotes(id) {
    return apiService.tabGet(`/dashboard_msp/manage_partners/${id}/quote/`);
  },

  getManagePartnersResources(id) {
    return apiService.tabGet(`/dashboard_msp/manage_partners/${id}/resources/`);
  },

  getManagePartnersSupport(id) {
    return apiService.tabGet(`/dashboard_msp/manage_partners/${id}/support/`);
  },

  getManagePartnersCTA(id) {
    return apiService.tabGet(
      `/dashboard_msp/manage_partners/${id}/call_to_action/`
    );
  },

  getLocations() {
    return apiService.tabGet('/dashboard_msp/profile/location/');
  },

  getClients(id) {
    return apiService.tabGet(`/dashboard_msp/public_profiles/${id}/clients/`);
  },

  getFeaturedContent(id) {
    return apiService.tabGet(
      `/dashboard_msp/public_profiles/${id}/featured-content/`
    );
  },

  getResources(id) {
    return apiService.tabGet(`/dashboard_msp/public_profiles/${id}/resources/`);
  },

  getTestimonials(id) {
    return apiService.tabGet(
      `/dashboard_msp/public_profiles/${id}/testimonials/`
    );
  },

  /*
    POST
  */

  saveCategories(data) {
    return apiService.post(`dashboard_msp/directory/categories/`, data);
  },

  addPartner(data) {
    return apiService.post('/dashboard_msp/public_profiles/', data);
  },

  sendInvitation(data) {
    return apiService.post('/dashboard_msp/find_partners/invite/', data);
  },

  resendPartnersInvite(data) {
    return apiService.post('/dashboard_msp/find_partners/resend/invite/', data);
  },

  saveShowcases(id, data) {
    return apiService.post(
      `/dashboard_msp/public_profiles/${id}/showcases/`,
      data
    );
  },

  saveCustomButton(data) {
    return apiService.post('/dashboard_msp/profile/contact_button/', data);
  },

  saveManagePartnersUseCases(id, data) {
    return apiService.post(
      `dashboard_msp/manage_partners/${id}/use_cases/`,
      data
    );
  },

  createManagePartnersQuote(id, data) {
    return apiService.post(`dashboard_msp/manage_partners/${id}/quote/`, data);
  },

  saveManagePartnersResources(id, data) {
    return apiService.post(
      `dashboard_msp/manage_partners/${id}/resources/`,
      data
    );
  },

  saveManagePartnersSupport(id, data) {
    return apiService.post(
      `dashboard_msp/manage_partners/${id}/support/`,
      data
    );
  },

  saveManagePartnersCTA(id, data) {
    return apiService.post(
      `dashboard_msp/manage_partners/${id}/call_to_action/`,
      data
    );
  },

  saveLocations(data) {
    return apiService.post('/dashboard_msp/profile/location/', data);
  },

  saveClients(id, data) {
    return apiService.post(
      `/dashboard_msp/public_profiles/${id}/clients/`,
      data
    );
  },

  saveFeaturedContent(id, data) {
    return apiService.post(
      `/dashboard_msp/public_profiles/${id}/featured-content/`,
      data
    );
  },

  saveResources(id, data) {
    return apiService.post(
      `/dashboard_msp/public_profiles/${id}/resources/`,
      data
    );
  },

  saveTestimonials(id, data) {
    return apiService.post(
      `/dashboard_msp/public_profiles/${id}/testimonials/`,
      data
    );
  },

  /*
    PUT
  */

  updateProfile(data) {
    return apiService.put('/dashboard_msp/profile/', data);
  },

  updateMatchmakingDetail(id, data) {
    return apiService.put(`/dashboard_msp/matchmaking/details/${id}/`, data);
  },

  updateSettings(data) {
    return apiService.put('/dashboard_msp/directory/settings/', data);
  },

  updateBranding(data) {
    return apiService.put('/dashboard_msp/directory/branding/', data);
  },

  updateLeadStatus(id, data) {
    return apiService.put(
      `/dashboard_msp/reseller/contact/status/update/${id}/`,
      data
    );
  },

  updatePublicProfile(id, data) {
    return apiService.put(`/dashboard_msp/public_profiles/${id}/`, data);
  },

  saveManagePartnersProfile(id, data) {
    return apiService.put(`dashboard_msp/manage_partners/${id}/`, data);
  },

  updateManagePartnersQuote(id, data) {
    return apiService.put(
      `dashboard_msp/manage_partners/${id}/quote/update/`,
      data
    );
  },

  updateManagePartnersCTA(id, data) {
    return apiService.put(
      `dashboard_msp/manage_partners/${id}/call_to_action/update/`,
      data
    );
  },

  /*
    DELETE
  */

  deletePartner(id) {
    return apiService.delete(`/dashboard_msp/public_profiles/${id}/`);
  },

  deleteMatchmakingDetail(id) {
    return apiService.delete(`/dashboard_msp/matchmaking/details/${id}/`);
  },

  deleteInvitation(id) {
    return apiService.delete(`/dashboard_msp/manage_partners/invite/${id}/`);
  },
};
